import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../api';
import { AppState } from '../../../store/models/app-state';
import { receiveDemands } from '../../demands/demand-actions';
import { receiveInquiries } from '../../inquiries/inquiry-actions';
import { receiveInvoices } from '../../invoices/invoice-overview/store/invoice-actions';
import { receivePurchaseOrders } from '../../purchase-orders/purchase-order-actions';
import { receiveSalesOrders } from '../../sales-orders/sales-order-actions';

export const DASHBOARD_REQUEST_START = 'DASHBOARD_REQUEST_START';
export const DASHBOARD_REQUEST_END = 'DASHBOARD_REQUEST_END';

export const startRequest = () => {
    return {
        type: DASHBOARD_REQUEST_START,
    };
};

export const endRequest = () => {
    return {
        type: DASHBOARD_REQUEST_END,
    };
};

export const fetchDashboardSearch = (searchParams: URLSearchParams) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(startRequest());
        const response = await api.dashboard.cget(searchParams);
        dispatch(endRequest());
        if (response.success) {
            dispatch(receiveInquiries(response.result.inquiries));
            dispatch(receiveSalesOrders(response.result.salesOrders));
            dispatch(receivePurchaseOrders(response.result.purchaseOrders));
            dispatch(receiveDemands(response.result.demands));
            dispatch(receiveInvoices(response.result.invoices));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
